<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
      <div class="modal-overlay" @click="back()"></div>
      <div class="modal">
        <article v-if="resource">
          <header>
            <figure class="no-radius">
              <i v-if="!resource.picture" class="icon icon-icon_person"></i>
              <img v-if="resource.picture" :src="resource.picture + '/fit/100x100'"/>
            </figure>
            <div>
              <span class="breadcrumb">
                  Product <i class="icon icon-icon_arrow-right"></i> Edit
              </span>
              <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
            </div>
            <div class="spacer"></div>
            <div class="buttons">
              <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
              <button @click="remove()" class="bt-primary bt-delete" v-if="resource.id"><span><icon name="trash-01"/></span></button>
              <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
            </div>
            <notice-published v-model="resource" label-published="Ce produit est actif." label-unpublished="Ce produit est inactif." :dates="true"></notice-published>
            <div v-if="is_variant">Ce produit est une variante, si vous souhaitez modifier ses attributs, éditer le template principal</div>
          </header>

          <main>

            <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

            <modal
                v-model="productVariant"
                v-if="isModalVisible"
                @close="closeModal"
                @validate="validateModal"/>

            <column style="display: flex; height:100%;">

            <aside v-if="resource && resource.id">

              <figure v-if="resource.medias && resource.medias.length">
                <img :src="resource.medias[0].url" width="100%"/>
              </figure>
              <figure v-else>
                <img src="/src/assets/images/placeholder-square.svg"/>
              </figure>
              <div style="display: flex;align-items: center;">
                <product-type v-model="resource"/>
                <div style="padding: 0 10px;"><img :src="'/src/assets/flags/'+locale_default+'.svg'" height="12"></div>
              </div>

              <h1 v-if="resource.translations[locale_default].name">{{ resource.translations[locale_default].name }}</h1>
              <p class="sku" v-if="resource.sku">{{ resource.sku }}</p>
              <p class="headline" v-if="resource.translations[locale_default].headline">{{ resource.translations[locale_default].headline }}</p>

              <!--
              <dl>
                <dt>{{ selling_price }}</dt>
                <dd>{{ resource.amount_selling_price }}</dd>
              </dl>

              <dl>
                <dt>{{ cost_price }}</dt>
                <dd>{{ resource.amount_cost_price }}</dd>
              </dl>
              -->

            </aside>

            <tabs :options="{ useUrlFragment: false }">
              <tab name="Information">
                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                <fieldset>
                  <h3>Type de produit</h3>
                  <p class="headline">Les produits de type "service" comporte une durée et peuvent être agender</p>

                  <div class="selector">
                    <label @click="selectType('product')" v-bind:class="{'active':resource.type_of == 'product'}">
                      <icon name="shopping-bag-01"/>
                      <span>
                          <strong>Produit</strong>
                          <p>Article de consommation</p>
                      </span>
                    </label>
                    <label @click="selectType('service')" v-bind:class="{'active':resource.type_of == 'service'}">
                      <icon name="calendar"/>
                      <span>
                          <strong>Service</strong>
                          <p>Prestation de service</p>
                      </span>
                    </label>
                    <label @click="selectType('giftcard')" v-bind:class="{'active':resource.type_of == 'giftcard'}">
                      <icon name="gift-01"/>
                      <span>
                          <strong>Bon cadeau</strong>
                          <p>Bon cadeau / Avoir</p>
                      </span>
                    </label>
                    <!--
                    <label @click="selectType('ticket')" v-bind:class="{'active':resource.type_of == 'ticket'}" disabled="disabled">
                      <icon name="ticket-01"/>
                      <span>
                          <strong>Billet / Pass</strong>
                          <p>Billet de concert</p>
                      </span>
                    </label>
                    <label @click="selectType('virtual')" v-bind:class="{'active':resource.type_of == 'virtual'}" disabled="disabled">
                      <icon name="disc-01"/>
                      <span>
                          <strong>Logiciel</strong>
                          <p>Logiciel de développement / licence</p>
                      </span>
                    </label>
                    -->
                  </div>

                  <hr>

                  <div v-show="resource.is_saleable_online">
                    <form-checklist label="Options d'expédition / réservation" :required="true" v-model="resource.has_options" :options="options()" :multiple="true" display="block"></form-checklist>
                  </div>

                </fieldset>

                <fieldset v-if="resource.type_of == 'giftcard'">
                  <h3>Paramétrage du coupon</h3>

                  <form-text :label="'Valeur'" :suffix="currency" v-model="resource.giftcard_value"></form-text>
                  <form-text :label="'Durée de validité'" hint="Laisser zéro si illimité" v-model="resource.giftcard_validity_in_years" default="0"></form-text>
                  <form-select-new label="Template"
                                   multiple="false"
                                   v-model="resource.giftcard_pdf_template"
                                   :default="resource.giftcard_pdf_template_id"
                                   :options="templates"></form-select-new>
                </fieldset>

                <fieldset>
                  <h3>Information du produit</h3>
                  <p class="headline"></p>

                  <form-gallery label="Images" v-model="resource.medias" width="200"></form-gallery>

                  <form-toggle label="Afficher au catalogue" v-model="resource.in_catalog" v-if="is_variant"></form-toggle>

                  <group-line-2>
                    <form-text :label="'SKU'" v-model="resource.sku" required="true"></form-text>
                    <form-text :label="'Groupe SKU'" v-model="resource.group"></form-text>
                  </group-line-2>

                  <form-text :label="'SKU fournisseur'" v-model="resource.sku_supplier"></form-text>

                  <form-barcode :label="'EAN'" v-model="resource.ean"></form-barcode>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-text :lang="client.id"
                                 :label="'Nom'"
                                 :translate-key="'name'"
                                 v-model="resource.translations[client.id].name"
                                 :translations="resource.translations"
                                 required="true"></form-text>
                    </div>
                  </div>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-text :lang="client.id" :translate-key="'headline'" :label="'Description courte'" v-model="resource.translations[client.id].headline" :translations="resource.translations"></form-text>
                    </div>
                  </div>

                  <form-text :label="'Nom court'" v-model="resource.shortname"></form-text>

                  <tabs :options="{ useUrlFragment: false }">
                    <tab name="Description">

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-html :translate-key="'description'" :lang="client.id" :translations="resource.translations" label="" v-model="resource.translations[client.id].description"></form-html>
                        </div>
                      </div>

                    </tab>
                    <tab name="Complement">

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-html :translate-key="'complement'" :lang="client.id" :translations="resource.translations" label="" v-model="resource.translations[client.id].complement"></form-html>
                        </div>
                      </div>

                    </tab>
                    <tab name="Composition">

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-html :translate-key="'composition'" :lang="client.id" :translations="resource.translations" label="" v-model="resource.translations[client.id].composition"></form-html>
                        </div>
                      </div>

                    </tab>
                    <tab name="Notice">

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-html :translate-key="'notice'" :lang="client.id" :translations="resource.translations" label="" v-model="resource.translations[client.id].notice"></form-html>
                        </div>
                      </div>

                    </tab>
                  </tabs>

                  <hr>
                  <h3>Tarifs</h3>
                  <p class="headline"></p>

                  <group-line-2>
                    <form-number :label="selling_price" v-model="resource.amount_selling_price" :suffix="currency" :step="0.05" required="true"></form-number>
                    <form-select label="Taxe" multiple="false" v-model="resource.tax" :default="resource.tax_id" :options="$store.state.taxes" required="true"></form-select>
                  </group-line-2>
                  <group-line-2>
                    <form-number :label="cost_price" v-model="resource.amount_cost_price" :suffix="currency" :step="0.05"></form-number>
                    <form-number :label="amount_donation" v-model="resource.amount_donation" :suffix="currency" :step="0.05"></form-number>
                  </group-line-2>

                  <div style="display:flex;align-items: flex-end;">
                    <div style="width: 80px;margin-right: 20px;"><form-number label="Prix pour" v-model="resource.amount_metric_unit_value" :step="0.05"></form-number></div>
                    <form-select multiple="false" v-model="resource.amount_metric_unit" :options="$store.state.metrics" required="true" name="id"></form-select>
                  </div>

                  <div class="form-field">
                    <div class="form-label">Règles de prix</div>
                    <div class="form-input">
                      <div class="product-price-rules">
                        <div class="product-price-rules-item" v-for="(item, index) in resource.price_rules" v-if="!item.deleted && resource.price_rules" :key="item._uid">
                          <form-number :suffix="currency" :step="0.05" required="false" v-model="item.discounted_amount"></form-number>
                          <form-number suffix="QTE" :step="1" required="false" v-model="item.quantity"></form-number>
                          <button @click="deletePricePerQuantity(index)" class="bt-remove">
                            <span class="icon icon-icon_close"></span>
                          </button>
                        </div>
                        <div><span @click="createPricePerQuantity()" class="link">Ajouter un rabais de quantité</span></div>
                      </div>
                    </div>
                  </div>

                  <hr>

                  <form-color-picker label="Couleur" v-model="resource.color"></form-color-picker>


                </fieldset>

                <fieldset>
                  <h3>Gestion dans le panier</h3>
                  <p class="headline"></p>

                    <form-number label="Quantité par défaut" v-model="resource.quantity_per_default"></form-number>
                    <form-number label="Quantité minimum" v-model="resource.quantity_min"></form-number>
                    <form-number label="Quantité incrémentale" v-model="resource.quantity_step"></form-number>
                    <form-number label="Quantité maximum" hint="Laisser zéro si non défini" v-model="resource.quantity_max"></form-number>

                </fieldset>


              </tab>
              <tab name="Détail">

                <fieldset>
                  <h3></h3>

                  <div v-show="resource.type_of == 'service'">
                    <form-number label="Durée prestation" v-model="resource.duration" suffix="minutes" :step="1"></form-number>
                    <form-number label="Temps de préparation" v-model="resource.preparation_time" suffix="minutes" :step="1"></form-number>
                  </div>

                  <form-toggle label="Saleable online" v-model="resource.is_saleable_online"></form-toggle>

                  <form-number label="Ordre d'affichage" v-model="resource.ord" :step="1"></form-number>

                  <form-select label="Gender" multiple="false" v-model="resource.gender" :default="resource.gender" :options="genders"></form-select>

                  {{ resource.released_at }}
                  <form-datetime label="Sortie du produit" v-model="resource.released_at" :hide-time="true" time="10:00:00"></form-datetime>

                  <form-number label="Rating" v-model="resource.rating" suffix="/ 5" :step="0.5"></form-number>

                  <form-select label="Marque" multiple="false" v-model="resource.brand" :options="brands" v-if="brands" :callback="setBrandLines"></form-select>
                  <form-select label="Collection" multiple="false" v-model="resource.brand_line" :options="brandlines" v-if="resource.brand && brandlines"></form-select>

                  <form-select label="Options" multiple="false" v-model="resource.option_behavior" :options="option_behaviors" v-if="option_behaviors"></form-select>
                </fieldset>

                <fieldset>
                  <h3>Catégories</h3>

                  <div class="tree static">
                    <sortable-tree :data="categories" mixinParentKey="$parent" :dragEnable="false" closeStateKey="$foldClose">
                      <template slot-scope="{item}">
                        <div class="custom-tree-content" :class="{'exitChild': item.children && item.children.length}">
                          <span>
                              <span v-if="item['$foldClose'] && item.children && item.children.length" @click="changeState(item)"><i class="icon icon-expand"></i></span>
                              <span v-else-if="!item['$foldClose'] && item.children && item.children.length" @click="changeState(item)"><i class="icon icon-collapse"></i></span>
                          </span>
                          <label>
                            <span><input type="checkbox" v-model="resource.categories" :value="item.id" :id="item.id"/></span>
                            <span class="name">{{ item.name }}</span>
                          </label>
                        </div>
                      </template>
                    </sortable-tree>
                  </div>
                </fieldset>

                <fieldset>
                  <h3>Complément</h3>

                  <component-attributes v-model="resource" :locale="locale"></component-attributes>

                </fieldset>

              </tab>
              <tab name="Packaging">

                <fieldset v-if="generatedProducts.length < 1">
                  <h3>Gestion des stocks</h3>
                  <p class="headline"></p>

                  <group-line-2>
                    <form-numeric label="Déduction du stock lors d'un achat" v-model="resource.stock_quantity_out" default="1"></form-numeric>
                  </group-line-2>

                  <form-toggle label="Activer le stock illimité" v-model="resource.unlimited_stock"></form-toggle>
                  <component-stock v-model="resource.stock.inventories" v-if="!resource.unlimited_stock && resource.stock && resource.stock.inventories"></component-stock>

                </fieldset>


                <fieldset>
                  <h3>Composition du produit</h3>
                  <p class="headline"></p>

                  <form-autocomplete label="Rechercher" v-model="product" :default="product" :service="productService" :callback="addProductToBundle"></form-autocomplete>

                  <div class="form-field form-products" v-if="resource.bundles && resource.bundles.length">
                    <div class="form-label">Produits liés</div>
                    <div class="form-input">
                      <div v-for="product,index in resource.bundles" v-if="resource.bundles" class="product-listing">
                        <div><img :src="product.picture + '/fit/100xauto'" v-if="product.picture"/></div>
                        <div>
                          <span class="name">{{ product.name }}</span>
                          <span class="sku">{{ product.sku }}</span>
                          <br>
                          <span><!--Déduction de stock par achat: <b style="font-weight:bold;">{{ resource.quantity }} pièce(s)</b>-->
                                                        <form-numeric :label="'Quantité'" v-model="product.quantity" :default="product.quantity"></form-numeric>
                                                    </span>
                        </div>
                        <button @click="removeProductFromBundle(index)" class="bt-remove"><i class="icon icon-icon_close"></i></button>
                      </div>
                    </div>
                  </div>
                </fieldset>

                <fieldset>
                  <h3>Mesure de la boîte</h3>
                  <p class="headline"></p>

                  <div style="display: flex; align-items: center;">
                    <div style="width:50%;">

                      <form-numeric :label="'Quantité d\'articles'" v-model="resource.package_quantity"></form-numeric>
                      <form-number :label="'Poids'" v-model="resource.package_weight" suffix="grammes"></form-number>
                      <form-number :label="'Largeur'" v-model="resource.package_width" suffix="mm"></form-number>
                      <form-number :label="'Hauteur'" v-model="resource.package_height" suffix="mm"></form-number>
                      <form-number :label="'Profondeur'" v-model="resource.package_depth" suffix="mm"></form-number>

                    </div>
                    <div style="width: 50%;text-align: center;">

                      <img :src="'/src/assets/images/dimensions.png'" width="100%" style="max-width: 500px;"/>

                    </div>
                  </div>

                </fieldset>

              </tab>
              <tab name="Options & Variants" v-if="!is_variant">

                <modal-combination
                    v-model="combinationSelected"
                    v-if="isModalCombinationVisible"
                    @close="closeModalCombination"
                    @validate="validateModalCombination"/>

                <fieldset v-if="types">
                  <h3>Type</h3>
                  <p class="headline"></p>

                  <form-select label="Product type" multiple="false" v-model="resource.product_type" :options="types" :callback="setTypes"></form-select>
                </fieldset>

                <fieldset>
                  <h3>Attributs</h3>
                  <p class="headline"></p>

                  <!--
                  <div class="notice success" v-if="generatedProducts" v-bind:class="{'show': generatedProducts}">
                      {{ generatedProducts.length }} variantes seront créés
                  </div>
                  -->

                  <draggable :list="resource.attrs" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">

                    <div v-for="attribute in resource.attrs">

                      <div class="form-field form-attribute">

                        <div class="form-label">{{ attribute.name }}</div>
                        <div class="form-input">
                          <div class="form-input-wrapper" style="min-height: 50px; padding: 4px; position: relative;">

                            <div>
                                <span v-for="combination, index in resource.combinations[attribute.slug]"
                                      @click="editCombination(combination, attribute.id, attribute.slug, index, $event)"
                                      v-if="resource.combinations[attribute.slug]"
                                      class="group"
                                      v-bind:style="{border:'1px solid '+attribute.color, background: attribute.bgcolor}"
                                      v-bind:class="{'as-attribute': combination[0][0].as != 'variation'}">

                                        <span v-for="group, i in combination">
                                            <span v-for="attr in group"
                                                  v-if="attr.slug" style="display: inline-block; text-transform: uppercase; font-weight: bold;">
                                                {{ attr.name }}<span v-if="group.length > 1">&nbsp;</span>
                                            </span><span v-if="combination.length > 1 && i < combination.length-1">, </span>

                                        </span>

                                    <button class="remove" @click="removeCombination(attribute.slug, index, $event)"><span class="icon icon-icon_close"></span></button>

                                </span>
                            </div>

                            <div @click="addCombination(attribute.id, attribute.slug, $event)" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 0;"></div>

                          </div>
                        </div>

                        <div>
                          <button @click="addCombination(attribute.id, attribute.slug, $event)"><span>ajouter</span></button>
                          <div><input type="checkbox" v-model="resource.options" :value="attribute.id"/> option</div>
                        </div>

                      </div>

                    </div>
                  </draggable>

                </fieldset>


                <fieldset v-if="generatedProducts && generatedProducts.length > 0">
                  <h3>Inventaire des produits</h3>
                  <p class="headline"></p>

                  <div style="margin-bottom: 20px;">

                    <label>
                      <input type="radio" id="active" v-model="listing" value="active"/>
                      <span>Active variants</span>
                    </label>

                    <label style="margin-left: 20px;">
                      <input type="radio" id="unactive" v-model="listing" value="unactive"/>
                      <span>Deleted variants</span>
                    </label>

                  </div>

                  <div class="datagrid product-variant-option">
                    <div class="datagrid-header">
                      <div>
                        <div></div>
                        <div><span>Name</span></div>
                        <div class="align-center"><span>Stock</span></div>
                        <div class="align-center"><span>{{ selling_price }}</span></div>
                        <div>Catalog</div>
                        <div class="actions" style="width: auto;max-width:1000px;">&nbsp;</div>
                      </div>
                    </div>
                    <div class="datagrid-body">
                      <div v-for="product in generatedProducts" v-if="(product.publication_state_id == 1 && listing == 'active') || (product.publication_state_id != 1 && listing != 'active')" v-bind:class="{deleted:product.publication_state_id != 1, hide: (product.publication_state_id == 1 && listing != 'active') || (!product.publication_state_id == 1 && listing == 'active')}" _dblclick="editVariant(product)">
                        <div class="picture no-radius">
                          <figure>
                            <img v-bind:style="{background: 'no-repeat center', backgroundImage: 'url(' + (product.medias && product.medias[0] ? product.medias[0].url : '') +')', backgroundSize: 'contain'}"
                                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=">
                          </figure>
                        </div>
                        <div class="auto">
                          <strong v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded" :title="product.variant_id">
                            {{ product.translations[client.id].name }}
                          </strong>
                          <div>{{ product.sku }}</div>
                          <!--
                          <div>
                              {{ product.variant_id }}
                          </div>
                          -->
                          <div class="attribute-listing">
                            <span v-for="attribute in product.resume" v-bind:style="{border: '1px solid '+attribute.color, background: attribute.bgcolor}">{{ attribute.name }}</span>
                          </div>
                        </div>
                        <div class="align-center" v-if="product.unlimited_stock">illimité</div>
                        <div class="align-center" v-if="!product.unlimited_stock">
                          -
                        </div>
                        <!--
                        <div>{{ product.sku }}</div>
                        -->
                        <div class="align-right" style="white-space: nowrap;">{{ product.amount_selling_price }} {{ currency }}</div>
                        <div><form-toggle label="" v-model="product.in_catalog"></form-toggle></div>
                        <div class="actions" style="width: auto;max-width:1000px;">
                          <ul>
                            <li v-show="product.publication_state_id != 1 && listing != 'active'"><button @click="cancelRemovedVariant(product)" title="Add to existing variant"><icon name="plus-circle"/></button></li>
                            <li v-show="product.publication_state_id == 1 && listing == 'active'"><button @click="removeVariant(product)" title="Remove from existing variant"><icon name="trash-01"/></button></li>
                            <li><button @click="editVariant(product)"><icon name="pencil-02"/></button></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                </fieldset>

              </tab>
              <tab name="SEO">

                <fieldset>
                  <h3>SEO</h3>
                  <p class="headline">Optimiser l'affichage de votre produit dans la recherche Google.</p>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-text :translate-key="'meta_url'" :translations="resource.translations" :lang="client.id" :label="'Url'" v-model="resource.translations[client.id].meta_url"></form-text>
                    </div>
                  </div>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-text :translate-key="'meta_title'" :translations="resource.translations" :lang="client.id" :label="'Meta-Title'" v-model="resource.translations[client.id].meta_title"></form-text>
                    </div>
                  </div>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-textarea :translate-key="'meta_description'" :translations="resource.translations" :lang="client.id" :label="'Meta-Description'" v-model="resource.translations[client.id].meta_description"></form-textarea>
                    </div>
                  </div>

                  <form-select-new label="Google Taxonomy" v-model="resource.google_taxonomy" :default="resource.google_product_category" :options="google_taxonomies" v-if="google_taxonomies"></form-select-new>

                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                      <form-textarea :translate-key="'search_index'" :lang="client.id" :translations="resource.translations" label="Mots clés" v-model="resource.translations[client.id].search_index"></form-textarea>
                    </div>
                  </div>

                </fieldset>

              </tab>
            </tabs>

            </column>

          </main>

          <footer>
          </footer>
        </article>

      </div>
    </div>
  </transition>
</template>
<script>

import ProductService from './ProductService.js';
import ProductTypeService from '../type/ProductTypeService.js';
import AttributeService from '../../config/attribute/AttributeService.js';
import CategoryService from '../category/CategoryService.js';
import BrandService from '../brand/BrandService.js';
import ProductOptionService from "../option/ProductOptionService";
import Edit from '../../../layouts/Edit.vue';
import ScopeService from '../../scope/ScopeService.js';

import attributeSelector from '../../config/attribute/Select.vue';
import Modal from './Modal.vue'
import modalCombination from './ModalCombination.vue'
import componentStock from "../../../components/Stock.vue";

import componentAttributes from "../../../components/Attributes.vue";
import PdfTemplateService from '../../config/pdf-template/PdfTemplateService.js';


export default {
  extends: Edit,
  components:{
    attributeSelector,
    Modal,
    modalCombination,
    componentStock,
    componentAttributes,
  },
  data () {
    return {
      is_variant: false,
      listing: "active",
      google_taxonomies: [],
      resource: {
        attributes: [],
        addressable: [],
        user: {
          scopes: []
        },
        templates: []
      },
      genders: [
        {id:'unisex', name:'Unisex'},
        {id:'male', name:'Monsieur'},
        {id:'female', name:'Madame'}
      ],
      has_options_product: [
        {id:'has_delivery', name:'Livraison à domicile', description:'Ce produit peut être livré'},
        {id:'has_shipping', name:'Envoi par transporteur', description:'Ce produit peut être expédié'},
        {id:'has_pickup', name:'Retrait dans nos magasins', description:'Ce produit peut être retiré'}
      ],
      has_options_service: [
        {id:'has_delivery', name:'Livraison à domicile', description:'Ce produit peut être livré'},
        {id:'has_shipping', name:'Envoi par transporteur', description:'Ce produit peut être expédié'},
        {id:'has_pickup', name:'Retrait dans nos magasins', description:'Ce produit peut être retiré'},
        {id:'has_schedule', name:'Rendez-vous nécessaire', description:'Nécessite un rendez-vous/réservation'}
      ],
      product: null,
      productService: null,
      companies: [],
      isLoading: false,
      currency: '',
      selling_price: '',
      cost_price: '',
      input_translate: '',
      brands: [],
      brandlines: [],
      option_behaviors: [],
      attributes: [],
      types: [],
      attributeValueSelectionInit: [],
      generatedProducts: [],
      categories: {name: '', children: []},

      isModalCombinationVisible: false,
      combinationSelected: {edit:false, data:null},

      isModalVisible: false,
      productVariant: null,
    }
  },
  mounted: function(){
    this.currency = this.$store.state.scope.currency_id
    this.selling_price = 'Prix de vente ' + (this.$store.state.scope.is_ttc?'TTC':'HT')
    this.cost_price = 'Prix de revient ' + (this.$store.state.scope.is_ttc?'TTC':'HT')
    this.amount_donation = 'Donation ' + (this.$store.state.scope.is_ttc?'TTC':'HT')

    this.productService = ProductService;

    CategoryService.tree().then((response) => {
      //console.log('tree', response);
      this.categories.children = response.data;
    })

    ScopeService.getGoogleTaxonomies().then((response) => {
      console.log('google_taxonomies', response);
      this.google_taxonomies = response.data;
    })

    PdfTemplateService.all().then(response => {
      this.templates = response.data
      this.isLoading = false
    });

  },
  methods:{
    selectType: function(typeOf)
    {
      //this.resource.is_service = bool;
      this.resource.type_of = typeOf;
      this.$forceUpdate()
    },
    options: function(){
      if( this.resource.type_of == 'service' ){
        return this.has_options_service;
      }else{
        return this.has_options_product;
      }
    },
    addProductToBundle: function(item){
      if( item ){
        let check = true;
        for(let product of this.resource.bundles){
          if( product.id == item.id ){
            check = false;
            product.quantity += 1;
            break;
          }
        }
        if( check ){
          this.resource.bundles.push(item);
        }
        this.$forceUpdate()
      }
    },
    removeProductFromBundle: function(index){
      this.resource.bundles.splice(index, 1);
      this.$forceUpdate()
    },
    addCombination: function(attributeId, combiKey, e){

      e.stopPropagation()
      this.combinationSelected.edit = false
      this.combinationSelected.attribute = this.copy( this.attributes[attributeId] )
      this.combinationSelected.is_variation = false
      this.combinationSelected.data = {}
      this.isModalCombinationVisible = true
      this.combinationSelected.index = null
      this.combinationSelected.keyIndex = combiKey
      this.combinationSelected.combination = []

    },
    editCombination: function(combination, attributeId, combiKey, combiIndex, e){

      e.stopPropagation()

      this.combinationSelected.edit = true
      this.combinationSelected.is_variation = combination[0][0].as == "variation" ? true : false
      this.combinationSelected.attribute = this.copy( this.attributes[attributeId] )
      this.combinationSelected.index = combiIndex
      this.combinationSelected.keyIndex = combiKey
      this.combinationSelected.data = {}

      let combinationTmp = []

      if( combination.length > 1 ){
        // Group
        for(let combi of combination) {
          if (combi.length > 1) {
            // Parent
            let array = []
            for (let item of combi) {
              //console.log("Parent A", item.slug)
              array.push({
                slug: item.slug,
                name: item.name,
                attribute_id: item.attribute_id,
                id: item.id
              })
            }
            combinationTmp.push(array)
          } else {
            // Single
            //console.log("Signle A", combi[0].slug)
            combinationTmp.push({
              slug: combi[0].slug,
              name: combi[0].name,
              attribute_id: combi[0].attribute_id,
              id: combi[0].id
            })
          }
        }
      }else{
        // Single
        if( combination[0].length > 1 ){
          // Parent
          let array = []
          for (let item of combination[0]) {
            //console.log("Parent B", item.slug)
            array.push({
              slug: item.slug,
              name: item.name,
              attribute_id: item.attribute_id,
              id: item.id
            })
          }
          combinationTmp.push(array)
        }else{
          // Single
          //console.log("Signle B", combination[0][0].slug)
          combinationTmp.push({
            slug: combination[0][0].slug,
            name: combination[0][0].name,
            attribute_id: combination[0][0].attribute_id,
            id: combination[0][0].id
          })
        }
      }

      this.combinationSelected.combination = combinationTmp
      this.isModalCombinationVisible = true


    },
    removeCombination: function(combiKey, index, e){
      e.stopPropagation()
      this.resource.combinations[combiKey].splice(index,1)
      this.$forceUpdate()
      this.generate()
    },
    closeModalCombination() {
      this.isModalCombinationVisible = false;
    },
    validateModalCombination() {

      //console.log("Combination", this.combinationSelected)

      if( !this.combinationSelected.edit ) {

        if (!this.resource.combinations[this.combinationSelected.keyIndex]) {
          this.resource.combinations[this.combinationSelected.keyIndex] = []
        }

        this.resource.combinations[this.combinationSelected.keyIndex].push([])
        this.combinationSelected.index = this.resource.combinations[this.combinationSelected.keyIndex].length-1

      }else{

        this.resource.combinations[this.combinationSelected.keyIndex][this.combinationSelected.index] = []

      }

      //console.log(this.combinationSelected.keyIndex, this.combinationSelected.index, this.resource.combinations)


      let added = 0

      // Insert
      if( this.combinationSelected.combination.length ){
        if( this.combinationSelected.combination[0].slug ){
          // Singles
          for(let item of this.combinationSelected.combination){
            let itemNew = {
              as: this.combinationSelected.is_variation ? 'variation' : 'attribute',
              id: item.id,
              attribute_id: item.attribute_id,
              name: item.name,
              slug: item.slug
            }
            let array = []
            array.push(itemNew)
            added ++
            this.resource.combinations[this.combinationSelected.keyIndex][this.combinationSelected.index].push(array)
          }

        }else{
          // Parents
          for(let combi of this.combinationSelected.combination){
            let array = []
            for(let item of combi) {
              let itemNew = {
                as: this.combinationSelected.is_variation ? 'variation' : 'attribute',
                id: item.id,
                attribute_id: item.attribute_id,
                name: item.name,
                slug: item.slug
              }
              array.push(itemNew)
            }
            let arrayMain = []
            arrayMain.push(array)
            added ++
            this.resource.combinations[this.combinationSelected.keyIndex][this.combinationSelected.index].push(array)
          }
        }
      }

      if( added == 0 ){
        this.resource.combinations[this.combinationSelected.keyIndex].splice(this.combinationSelected.index,1)
      }

      this.generate()
      this.$forceUpdate()
      this.closeModalCombination()

    },
    removeVariant: function(item){
      item.publication_state_id = 0
    },
    editVariant: function(item){
      this.productVariant = item
      this.productVariant.option_behaviors = this.option_behaviors
      this.isModalVisible = true
    },
    createPricePerQuantity: function () {
      if (!this.resource.price_rules) {
        this.resource.price_rules = [];
      }
      this.resource.price_rules.push({
        discounted_amount: 0,
        quantity: 0,
        is_number: 1,
        created_at: null,
        deleted: null,
      });
      this.$forceUpdate();
    },
    deletePricePerQuantity: function (index) {
      let ask = confirm("Supprimer ce rabais de quantité ?");
      if( ask ){
        this.resource.price_rules.splice(index, 1);
        this.$forceUpdate()
        this.$emit('input', this.resource.price_rules);
      }
    },
    closeModal() {
      this.productVariant = null;
      this.isModalVisible = false;
    },
    validateModal() {
      let behavior_id = this.productVariant.option_behavior && this.productVariant.option_behavior.id ? this.productVariant.option_behavior.id : null
      this.productVariant.option_behavior_id = behavior_id || null
      this.closeModal()
    },
    cancelRemovedVariant: function(item){
      item.publication_state_id = 1
    },
    setTypes: function(arg){
      if( arg ) {
        this.updateAttributes();
        //this.updateOptions();
      }
    },
    setBrandLines: function(arg){
      if( arg && arg.lines ){
        this.resource.brand_line = null
        this.brandlines = arg.lines
        for(let line of this.brandlines){
          if( line.id == this.resource.brand_line_id ){
            this.resource.brand_line = line;
            break;
          }
        }
      }
    },
    resourceLoaded: function(){
      this.setTranslations(['name','description','search_index','complement','composition','notice','headline','promotion','meta_url','meta_title','meta_description']);
      let categories = [];
      if( this.resource.categories ){
        for(let item of this.resource.categories){
          categories.push(item.id);
        }
      }

      this.is_variant = (this.resource.variant_id || this.resource.parent_id) ? true : false;

      this.resource.is_saleable_online = this.resource.id ? this.resource.is_saleable_online : true

      //this.resource.type = null;
      this.resource.categories = categories

      this.resource.combinations = this.resource.combinations ? this.resource.combinations : {}
      this.resource.combinations = Array.isArray(this.resource.combinations) ? {} : this.resource.combinations

      this.resource.attrs = []//this.resource.attrs ? this.resource.attrs : []
      this.attributeValueSelectionInit = this.copy( this.resource.attrs )

      this.resource.options = this.resource.options ? this.resource.options : [];

      this.resource.inventory = this.resource.inventory ? this.resource.inventory : [];

      this.resource.bundles = this.resource.bundles || []

      this.resource.amount_metric_unit_value = this.resource.amount_metric_unit_value ? this.resource.amount_metric_unit_value : 1;
      this.resource.amount_metric_unit = this.resource.amount_metric_unit ? this.resource.amount_metric_unit : 'unit';

      let bundleTmp = [];
      for(let product of this.resource.bundles){
        let tmp = product;
        tmp.quantity = product.pivot.quantity;
        bundleTmp.push(tmp);
      }

      this.resource.bundles = bundleTmp;

      /* CONVERT DATES TO LOCAL TIMZONE */
      this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null
      this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null
      /*****/

      BrandService.all().then(response => {
        console.log("Brands loaded", this.resource.brand_id, response.data)
        this.brands = response.data
        this.isLoading = false
        for(let item of this.brands){
          if( item.id == this.resource.brand_id ){
            this.resource.brand = item;
            console.log("Set Brand", item.lines)
            break;
          }
        }
      })

      ProductOptionService.all().then(response => {
        console.log("Option behaviors loaded", this.resource.option_behavior, response.data)
        this.option_behaviors = response.data
        this.isLoading = false
        for(let item of this.option_behaviors){
          if( item.id == this.resource.option_behavior.id ){
            this.resource.option_behavior = item;
            console.log("Set Option behavior", item.lines)
            break;
          }
        }
      })

      // Assign type to product
      ProductTypeService.all().then(response => {
        this.types = []
        this.types.push({id:null, name:'Tous les attributs'})
        for(let item of response.data){
          this.types.push(item)
        }
        this.isLoading = false
        let type = null;
        for(let item of this.types){
          if( item.id == this.resource.product_type_id ){
            type = item;
          }
        }

        if( type == null ){
          type = this.types[0]
        }
        //console.log("types", this.types)
        this.resource.product_type = type;

        AttributeService.allForProducts().then(response => {
          this.attributes = []
          this.isLoading = false

          for(let item of response.data){
            if( !item.parent_id){
              this.attributes[item.id] = item;
            }
          }

          //console.log("this.attributes", this.attributes)

          this.updateAttributes();
          this.generate()

        })
      })

      this.initialize()
    },
    getResource: function(){
      return ProductService
    },
    beforeUpdate: function(Resource){
      Resource.variants = this.copy( this.generatedProducts )
      //console.log("list", this.resource.variants);
      //this.resource.options = this.options

      return true;
    },
    limitText (count) {
      return `and ${count} other countries`
    },
    asyncFind (query) {
      this.isLoading = true
      CompanyService.query('?query=' + query ).then(response => {
        this.companies = response.data.data
        this.isLoading = false
      })
    },
    clearAll () {
      this.resource.companies = []
    },
    changeState (item) {
      this.$set(item, '$foldClose', !item['$foldClose'])
    },
    getValuesById:function(id){
      for (let attribute of this.attributes ) {
        if( id == attribute.id ){
          return attribute.values;
        }
      }
      return []
    },
    getAttributeValueName:function(id, valueId){
      for (let attribute of this.resource.attrs ) {
        if( id == attribute.id ){
          for (let value of attribute.values ) {
            if( valueId == value.id ){
              return {
                name: value.name,
                as: attribute.as
              };
            }
          }
          break;
        }
      }
    },
    generate: function(){

      this.getResource().generate(this.resource).then((response) => {

        let variants = response.data;
        for (let item of variants ) {
          this.setTranslationsTo(item, ['name','description','search_index','complement','composition','notice','headline','promotion','meta_url','meta_title','meta_description']);
        }
        this.generatedProducts = variants || [];

        console.log("variants", this.generatedProducts);
        this.$forceUpdate();
      })

    },
    getAttributeSelection:function(id, valueid){
      for (let item of this.attributeValueSelectionInit ) {
        if( id == item.id ){
          for (let value of item.selection ) {

            if( valueid == value.id ){
              return value;
            }
          }
        }
      }
      return null
    },
    getAttribute:function(id){
      for (let item of this.attributeValueSelectionInit ) {
        if( id == item.id ){
          return item;
        }
      }
      return null
    },
    updateAttributes:function(){

      let selectedAttributes = this.attributes;
      if( this.resource.product_type && this.resource.product_type.attributes ){
        selectedAttributes = this.resource.product_type.attributes;
      }

      //console.log("updateAttributes", this.attributes)

      // ALL
      this.attributesLoaded = false
      this.resource.attrs = []
      let order = 0
      for (let attr of selectedAttributes ) {
        if( attr ){
          let attribute = this.copy( attr )
          let attributeOptions = this.getAttribute(attribute.id);
          if( attributeOptions ){
            attribute.is_sku = attributeOptions.is_sku
            attribute.concat_name = attributeOptions.concat_name
            attribute.concat_amount = attributeOptions.concat_amount
            attribute.as = attributeOptions.as ? attributeOptions.as :'attribute'
            attribute.ord = attributeOptions.ord
            attribute.selection = []
          }else{
            attribute.is_sku = 0
            attribute.concat_name = 0
            attribute.concat_amount = 0
            attribute.as = 'attribute'
            attribute.ord = order
            attribute.selection = []
          }
          order++

          //console.log("Attribute generate...")


          for (let item of attribute.values ) {
            let option = this.getAttributeSelection(attribute.id, item.id)
            item.checked = 0
            if( option ){
              item.checked = 1
              item.amount_variation = option.amount_variation
              attribute.selection.push(item);
            }
          }

          this.resource.attrs.push(attribute)
        }
      }
      this.resource.attrs.sortOn('ord')
      this.attributesLoaded = true
      this.$forceUpdate()
    }
  },
  watch: {
    'resource.combinations': {
      handler: function (val, oldVal) {
        //console.log("update combinations", val)
        if( val && val.length && this.attributesLoaded && !this.resource.parent_id ){
          this.generate()
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/shop/product/Edit.vue